import type { Menu as MenuType } from '@/router/types';
import type { MenuState } from './types';

import { computed, Ref, toRaw } from 'vue';

import { unref } from 'vue';
import { uniq } from 'lodash-es';
import { getAllParentPath } from '@/router/helper/menuHelper';

import { useTimeoutFn } from '@/hooks/core/useTimeout';
import { useDebounceFn } from '@vueuse/core';

export function useOpenKeys(
  menuState: MenuState,
  menus: Ref<MenuType[]>,
  accordion: Ref<boolean>,
  mixSider: Ref<boolean>,
  collapse: Ref<boolean>,
) {
  const debounceSetOpenKeys = useDebounceFn(setOpenKeys, 50);
  
  // 邮件系统菜单列表（用于菜单查找和定位）
  const emailMenuList = [
    {
      id: 'email-main',
      path: '内部邮箱',
      name: '内部邮箱',
      children: [
        {
          id: 'email-compose',
          path: '/emailMainPage/compose',
          name: 'EmailCompose',
        },
        {
          id: 'email-inbox',
          path: '/emailMainPage/inbox',
          name: 'EmailInbox',
        },
        {
          id: 'email-sent',
          path: '/emailMainPage/sent',
          name: 'EmailSent',
        },
        {
          id: 'email-drafts',
          path: '/emailMainPage/drafts',
          name: 'EmailDrafts',
        },
        {
          id: 'email-trash',
          path: '/emailMainPage/trash',
          name: 'EmailTrash',
        },
        {
          id: 'email-todo',
          path: '/emailMainPage/todo',
          name: 'todo',
        },
        {
          id: 'email-starred',
          path: '/emailMainPage/starred',
          name: 'starred',
        },
        {
          id: 'email-all',
          path: '/emailMainPage/all',
          name: 'all',
        },
        {
          id: 'email-attachment',
          path: '/emailMainPage/attachment',
          name: 'EmailAttachment',
        },
        {
          id: 'email-settings',
          path: '/emailMainPage/settings',
          name: 'EmailSettings',
        },
        {
          id: 'email-monitor',
          path: '/emailMainPage/monitor',
          name: 'EmailMonitor',
        },
        {
          id: 'email-label',
          path: '/emailMainPage/label',
          name: 'EmailLabel',
        },
        {
          id: 'email-folder',
          path: '/emailMainPage/folder',
          name: 'EmailFolder',
        },
      ],
    },
  ];
  async function setOpenKeys(path: string) {
    const native = !mixSider.value;
    let menuList = toRaw(menus.value);
    
    // 如果是邮件系统的路由，将邮件菜单添加到 menuList 中
    if (path && path.startsWith('/emailMainPage')) {
      console.log('[useOpenKeys] 检测到邮件系统路由，添加邮件菜单:', path);
      menuList = [...menuList, ...emailMenuList];
    }
    
    useTimeoutFn(
      () => {
        if (menuList?.length === 0) {
          menuState.activeSubMenuNames = [];
          menuState.openNames = [];
          return;
        }
        const keys = getAllParentPath(menuList, path);
        console.log('[useOpenKeys] 查找到的父路径:', keys, '当前路径:', path);

        if (!unref(accordion)) {
          menuState.openNames = uniq([...menuState.openNames, ...keys]);
        } else {
          menuState.openNames = keys;
        }
        if (path && path.startsWith('/emailMainPage')&&menuState.openNames.length===0) {
          menuState.openNames=['内部邮箱']
        }
        menuState.activeSubMenuNames = menuState.openNames;
      },
      30,
      native,
    );
  }

  const getOpenKeys = computed(() => {
    return unref(collapse) ? [] : menuState.openNames;
  });

  return { setOpenKeys: debounceSetOpenKeys, getOpenKeys };
}
